<template>
  <AIVDialog :visible.sync="isVisible" title="Compliance Check" width="500px">
    <div class="compliance-warning-content">
      <!-- Blocks (cannot proceed) -->
      <div v-if="blocks.length > 0" class="mb-3">
        <div
          v-for="(block, idx) in blocks"
          :key="'block-' + idx"
          class="alert alert-danger"
          style="background: rgba(244, 67, 54, 0.15); border: 1px solid rgba(244, 67, 54, 0.4); border-radius: 6px; padding: 12px 15px; color: #f44336; margin-bottom: 8px;"
        >
          <i class="fa-solid fa-ban mr-1"></i>
          <strong>{{ block.type }}:</strong> {{ block.message }}
        </div>
      </div>

      <!-- Warnings (can proceed after acknowledgment) -->
      <div v-if="warnings.length > 0" class="mb-3">
        <div
          v-for="(warning, idx) in warnings"
          :key="'warn-' + idx"
          class="alert"
          :style="getWarningStyle(warning)"
        >
          <i :class="getWarningIcon(warning)" class="mr-1"></i>
          <strong>{{ warning.type }}:</strong> {{ warning.message }}
        </div>
      </div>

      <!-- Acknowledge checkbox (only for warnings, not blocks) -->
      <div v-if="blocks.length === 0 && warnings.length > 0" class="mt-3">
        <el-checkbox v-model="acknowledged">
          I acknowledge these compliance warnings and wish to proceed with clock-in.
        </el-checkbox>
      </div>

      <!-- Info message when only blocks -->
      <div v-if="blocks.length > 0" class="mt-3">
        <p style="color: #999; font-size: 13px;">
          <i class="fa-solid fa-info-circle"></i>
          You cannot clock in until the above compliance issues are resolved.
          Please upload updated documents or contact your manager for a waiver.
        </p>
      </div>
    </div>

    <template slot="footer">
      <div class="text-center">
        <el-button @click="isVisible = false">Cancel</el-button>
        <el-button
          v-if="blocks.length === 0"
          type="primary"
          :disabled="!acknowledged"
          @click="proceed"
        >
          <i class="fa-solid fa-check"></i> Proceed with Clock-In
        </el-button>
      </div>
    </template>
  </AIVDialog>
</template>

<script>
import AIVDialog from "@/components/AIVDialog.vue";

export default {
  name: "ComplianceWarningModal",
  components: { AIVDialog },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    blocks: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      acknowledged: false,
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.acknowledged = false;
        this.$emit("update:visible", value);
      },
    },
  },

  methods: {
    getWarningStyle(warning) {
      if (warning.severity === "grace_period") {
        return "background: rgba(255, 152, 0, 0.15); border: 1px solid rgba(255, 152, 0, 0.4); border-radius: 6px; padding: 12px 15px; color: #FF9800; margin-bottom: 8px;";
      }
      if (warning.severity === "expired") {
        return "background: rgba(244, 67, 54, 0.15); border: 1px solid rgba(244, 67, 54, 0.4); border-radius: 6px; padding: 12px 15px; color: #f44336; margin-bottom: 8px;";
      }
      return "background: rgba(255, 193, 7, 0.15); border: 1px solid rgba(255, 193, 7, 0.4); border-radius: 6px; padding: 12px 15px; color: #ffc107; margin-bottom: 8px;";
    },

    getWarningIcon(warning) {
      if (warning.severity === "grace_period") return "fa-solid fa-hourglass-half";
      if (warning.severity === "expired") return "fa-solid fa-exclamation-circle";
      return "fa-solid fa-exclamation-triangle";
    },

    proceed() {
      this.$emit("proceed");
      this.isVisible = false;
    },
  },
};
</script>
